<div class="row" [formGroup]="formGroup" [ngClass]="{'form-disabled': readonly}" >
    <div class="col-lg-12 kt-margin-bottom-20-mobile section-margin-top-60" *ngIf="!landAreaLowLevelTitle">
        <h5 class="my-3 text-mad text-uppercase">
            Parcel Identification
        </h5>
        <hr class="active" />
    </div>
    <div class="col-lg-12 mb-2">
        <mat-label>Would you like to add information on the land</mat-label>
        <mat-radio-group class="ml-4" formControlName="add_info_on_land">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
    </div>

    <ng-container *ngIf="formGroup.controls.add_info_on_land.value">
        <div class="col-12">
            <agm-map [latitude]="centerLat" [longitude]="centerLng" [zoom]="15" [usePanning]="true"
                [clickableIcons]="false" [scrollwheel]="null" (mapReady)="onMapReady($event)">
                <agm-map-type-control></agm-map-type-control>
                <button type="button" id="DeleteShape" class="btn btn-white ml-3 mt-1 p-0 map-button"
                    style="width: 30px; height: 26px" (click)="onDeleteShape()">
                    <mat-icon inline>remove_circle_outline</mat-icon>
                </button>
            </agm-map>
        </div>

        <div class="col-12">
            <div class="row" *ngIf="formGroup.controls.boundary_type_id.value == 3">
                <div class="col-12 mb-4" style="display: flex; justify-content: end;">
                    <button mat-raised-button type="button" class="btn btn-primary" color="primary" (click)="onAddPoint()">
                        Add a point
                    </button>
                </div>

                <div class="col-12 mb-4">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>
                                    No
                                </th>
                                <th>
                                    X
                                </th>
                                <th>
                                    Y
                                </th>
                                <th>Length ({{ staticUnitLengthName }})</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of (dataSource$|async); let i = index">
                                <th>
                                    {{ i + 1 }}
                                </th>
                                <td>
                                    <ng-container>
                                        <input type="text" [value]="item.point.lat" (focusout)="onFocusOut($event, 'lat', item.point)" />
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container>
                                        <input type="text" [value]="item.point.lng" (focusout)="onFocusOut($event, 'lng', item.point)" />
                                    </ng-container>
                                </td>
                                <td>
                                    {{item.length  
                                        ? staticUnit == 2 ? item.length * imperial_length : item.length
                                        : 'N/A'}}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>
                                    Total ({{staticUnitName}})
                                </th>
                                <td colspan="3">
                                    <ng-container *ngIf="(area$|async) as area">
                                        <ng-container *ngIf="area != null">
                                            {{area.toPrecision(6)}} {{staticUnitName}}
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="!(area$|async)">
                                        N/A
                                    </ng-container>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-4 mb-4">
                    <mat-form-field class="mat-form-field-fluid">
                        <input matInput placeholder="Land Parcel ID" formControlName="land_parcel_name" />
                    </mat-form-field>
                </div>

                <div class="col-12 mb-4">
                    <div class="row">
                        <div class="col-6">
                            Add coordinates of each boundary cover or pivot point of the land parcel ?
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-lg-6">
                            <mat-radio-group formControlName="boundary_type_id">
                                <mat-radio-button [value]="1">No</mat-radio-button>
                                <mat-radio-button [value]="2">Draw</mat-radio-button>
                                <mat-radio-button [value]="3">Write Down</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
                <div class="col-6 mb-4">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-select placeholder="Coordinate Reference System" formControlName="coordinate_reference_system_id">
                            <mat-option *ngFor="let coordinateReferenceSystem of coordinateReferenceSystems" [value]="coordinateReferenceSystem.id">{{coordinateReferenceSystem.name}}</mat-option>
                        </mat-select>
                        <mat-icon
                            matSuffix
                            class="cursor-pointer"
                            (click)="$event.stopPropagation();"
                            container="body"
                            [ngbPopover]="'TOOLTIP.LAND_PARCEL.CRS.DESCRIPTION' | translate">help
                        </mat-icon>
                        <mat-error>
                            Coordinate Reference System
                            <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!-- <div class="col-lg-12 mb-10">
            <kt-land-parcel-map
                [points]="data.points"
                [centerLat]="centerLat"
                [centerLng]="centerLng"
                [staticUnit]="2"
                [staticUnitLengthName]="'M'"
                [staticUnitName]="'sqm'">
            </kt-land-parcel-map>
        </div> -->
        <kt-land-area-list
            class="col-lg-12"
            [lowLevelTitle]="landAreaLowLevelTitle"
            [landAreaComponentListSubject]="data.landAreaComponentListSubject"
            [landAreaSubject]="data.landAreaSubject"
            [showOtherFields]="true">
        </kt-land-area-list>
    </ng-container>
</div>